import React, { useEffect, useState, useCallback, useRef } from "react";
import { Layout, Button, Avatar, Dropdown, Menu, message } from "antd";
import _ from "lodash";
import { Link } from "react-router-dom";
import HomeMenuModal from "./component_home_menu_modal";
import CommonLoadingModal from "./component_common_loading_modal";
import classnames from "classnames";
import landingLogo from "../assets/images/landingpage/landing_logo_03.png";
import IconArrow from "../assets/images/ic_arrow_down.svg";
import IconMenu from "../assets/images/home/mobile-menu-white.svg";
import "./component_cr_header.less";
import { Button as MatButton } from "@material-ui/core";
import { getToken, setToken } from "../utils/authStorage";
import {
  router_homepage_canvas,
  router_homepage_opportunity,
  router_get_started,
  router_dashboard_post_job_opp,
  router_company_info,
  router_add_canvas,
  TargetType,
  router_student_pro_landing,
  router_business_payment,
  LandingPage,
  router_my_dashboard,
} from "../utils/enum";
import { scBaseUrl, TRIMM_URL, partnersUrl, LOGOS } from "../utils/constants";
import {
  ModelNotifications,
  module_notifications,
  GetNotificationCount,
} from "./../models/model_notifications";
import { modle_user, LoginWithTokenAction, User } from "../models/model_user";
import { setUserLoginInfoAction } from "../models/model_home";
import {
  module_post_job_opp,
  MODULE_POST_JOB_OPP,
} from "../models/model_post_job_opp";
import { module_chat } from "../models/model_chat";
import { initChatClient } from "../utils/chatHelper";
import { searchMyCanvases, getCanvas } from "../api/Canvas";
import { mapProp, doAction, doFunction } from "module-reaction";
import { HashLink } from "react-router-hash-link";
import { getOptimizedPath, getStartedViaSource } from "../utils/utils";
import { getUtoken } from "../api/Auth";
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import store from '../utils/store';
import { redirectToGetStarted } from "../utils/redirect";
import {
  COMMUNITY_NAV_URL,
  fetchUserCanvasFlags,
  UserCanvasFlags,
} from "../utils/userNavCanvas";
import {
  AvatarMenuItem,
  buildAdminMenuItems,
  buildAvatarMenuItems,
  getUserInitials,
} from "../utils/headerUserMenu";


const { Header } = Layout;
const scImgPathLogo = scBaseUrl + "cm_sc_logo.png";

interface Props extends ModelNotifications {
  className?: string;
  hidden?: boolean;
  history?: any;
  pathname?: string;
  onLogin?: Function;
  onLogout?: Function;
  curUser?: User;
  unreadCount?: number;
}

const router_homepage_canvas_professional = router_homepage_canvas.replace(
  ":type",
  "professional"
);
const router_homepage_canvas_business = router_homepage_canvas.replace(
  ":type",
  "business"
);
const router_schol_canvas_business = router_homepage_canvas.replace(
  ":type",
  "school"
);

const CRHeader: React.FC<Props> = (props) => {
  const {
    className,
    hidden,
    history,
    pathname,
    onLogin,
    onLogout,
    notificationCount,
    unreadCount = 0,
    curUser,
  } = props;

  const [showMenuModal, setShowMenuModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(
    (curUser &&
      curUser.profile &&
      curUser.profile.target &&
      curUser.profile.target === TargetType.ADMIN) ||
      false
  );
  const [isLandingPage, setIsLandingPage] = useState(false);
  const [wellaLanding, setWellaLanding] = useState(false);
  const [userCanvasFlags, setUserCanvasFlags] = useState<UserCanvasFlags>({
    hasSchoolCanvas: false,
    hasBusinessCanvas: false,
    hasPersonalCanvas: false,
    hasStudentCanvas: false,
    hasApplications: false,
  });
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  const location = useLocation();

  const handleCanvasU = async () => {
    // const tab = window.open();
    // try {
      window.open(COMMUNITY_NAV_URL, "_blank", "noopener,noreferrer");
    //   const { utoken } = await getUtoken();
    //   if (utoken) {
    //       tab.location.href = `https://u.canvasme.com/?utoken=${utoken}`
    //   }
    //   history.replace(router_my_dashboard)
    // } catch (error) {
    //   console.log('Error in handleCanvasu', error)
    // }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const backToAdmin = urlParams.get('backtoadmin') === 'true';
    // const fromCanvasU = urlParams.get('from') === 'canvasu';

    if (backToAdmin) {
      handleAdmin();
    }

    // if (curUser && fromCanvasU) {
    //   handleCanvasU();
    // }

    const pageName = location.pathname.replace('/', '');
    let isLanding = false;
    for (const key in LandingPage) {
      if (LandingPage[key] === pageName) {
        isLanding = true;
        break;
      }
    }
    if (isLanding) {
      if(pageName === 'studentpro') {
        dispatch({
          type: 'MARK_LANDING_PAGE_VISITED',
          payload: { source: 'jeffrey', rep: null },
        });
        return;
      }
      const storeValue = store.getState().landingPage.visitedLandingPage;
      const urlParams = new URLSearchParams(location.search);
      const repValue = urlParams.get('rep');
      if (storeValue.source) {
        console.log('Landing Page Already Visited')
      } else {
        console.log('Landing Page Visited')
        if(pageName === 'saloncentric') {
          axios.get('https://api.ipify.org?format=json')
            .then(response => {
              console.log(response.data.ip);
              axios.post(process.env.REACT_APP_BASE_URL+'/landing/page-visited', 
                { ip: response.data.ip, source: pageName, rep: repValue, page: pageName
              }).then(response => {
                console.log(response);
              }).catch(error => {
                console.error("Error fetching IP address:", error);
              });
            })
            .catch(error => {
              console.error("Error fetching IP address:", error);
            });
        }
        setIsLandingPage(true);
        if(pageName === 'wella') {
          setWellaLanding(true);
        }
        
        dispatch({
          type: 'MARK_LANDING_PAGE_VISITED',
          payload: { source: pageName, rep: repValue },
        });
      }
    }
  }, [location]);

  useEffect(() => {
    if (!getToken()) {
      setUserCanvasFlags({
        hasSchoolCanvas: false,
        hasBusinessCanvas: false,
        hasPersonalCanvas: false,
        hasStudentCanvas: false,
        hasApplications: false,
      });
      return;
    }
    fetchUserCanvasFlags().then(setUserCanvasFlags);
  }, [curUser?.id]);

  useEffect(() => {
    if (!userMenuOpen) {
      return undefined;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userMenuOpen]);

  const isHome =
    pathname === "/" ||
    pathname === "" ||
    pathname === "/paulmitchell" ||
    pathname === "/saloncentric";

  const isLoggedIn = !!token;

  const navigateMenuItem = (item: AvatarMenuItem) => {
    setUserMenuOpen(false);
    if (item.onClick) {
      item.onClick();
      return;
    }
    if (!item.href) {
      return;
    }
    const nextBase = process.env.REACT_APP_NEXT_URL || "";
    if (item.href.startsWith("http") || (nextBase && item.href.startsWith(nextBase))) {
      window.location.href = item.href;
      return;
    }
    history.push(item.href);
  };

  const renderMenuPopover = () => {
    const adminItems = curUser?.profile?.target === "admin"
      ? buildAdminMenuItems(history)
      : [];
    const userItems = buildAvatarMenuItems({
      userCanvasFlags,
      hasPersonalCanvas: userCanvasFlags.hasPersonalCanvas,
      onBeautistaConnectClick: handleCanvasU,
      onSignOutClick: () => onLogout && onLogout(),
      isAdmin: false,
      adminItems: [],
    });

    const renderMenuItem = (item: AvatarMenuItem, index: number) => {
      if (item.kind === "divider") {
        return <div key={`divider-${index}`} className="menu-popover-divider" />;
      }
      if (item.kind === "sectionLabel") {
        return (
          <span key={`section-${index}`} className="menu-popover-section-label">
            {item.label}
          </span>
        );
      }
      const className = [
        item.danger ? "sign-out" : "",
        item.addAccount ? "add-account" : "",
        (item.label === "Message" && unreadCount > 0) ||
        (item.label === "Notifications" && notificationCount > 0)
          ? "notification-active"
          : "",
      ].filter(Boolean).join(" ");

      return (
        <span
          key={`${item.label}-${index}`}
          className={className}
          onClick={() => navigateMenuItem(item)}
        >
          <span>{item.label}</span>
          {item.description && (
            <small className="menu-popover-desc">{item.description}</small>
          )}
        </span>
      );
    };

    return (
      <div className="menu-popover-content">
        {adminItems.length > 0 && (
          <div className="menu-popover-admin-scroll">
            {adminItems.map((item, index) => renderMenuItem(item, index))}
          </div>
        )}
        {adminItems.length > 0 && <div className="menu-popover-divider" />}
        {userItems.map((item, index) => renderMenuItem(item, index))}
      </div>
    );
  };

  var token = getToken();
  var userMenu: any = null;
  function checkLoginThenGo(location: string) {
    return token ? location : router_get_started;
  }

  if (token) {
    const initials = getUserInitials(
      curUser?.profile?.firstName,
      curUser?.profile?.lastName
    );
    userMenu = (
      <div className="user-menu-wrap" ref={userMenuRef}>
        <button
          type="button"
          className={`user-sec ${userMenuOpen ? "user-sec-open" : ""}`}
          onClick={() => setUserMenuOpen((open) => !open)}
          aria-expanded={userMenuOpen}
        >
          {curUser?.profile?.avatar ? (
            <Avatar
              icon="user"
              src={curUser.profile.avatar}
              className="avatar"
            />
          ) : (
            <span className="avatar-initials">{initials}</span>
          )}
          <span className="name">
            {curUser?.profile?.firstName}
          </span>
          <img src={IconArrow} alt="" className="ic-arrow" />
        </button>
        {userMenuOpen && (
          <div className="user-dropdown-menu">
            {renderMenuPopover()}
          </div>
        )}
      </div>
    );
  } else if (!token) {
    userMenu = (
      <div>
        <span
          className="text login"
          onClick={() =>
            onLogin &&
            (history.location.pathname !== "/paulmitchell"
              ? onLogin()
              : history.push("/sign-in?school=paul_mitchell"))
          }
        >
          SIGN IN
        </span>
        <Button
          className={`btn-primary-light btn-start ${
            history.location.pathname === "/paulmitchell" ? "hidden" : ""
          }`}
          onClick={() => {
              if (history.location.pathname.includes(router_student_pro_landing)) {
                getStartedViaSource('jeffrey');
              } else if (history.location.pathname.includes('/wella')) {
                getStartedViaSource('wella');
              } else {
                redirectToGetStarted();
              }              
            }
          }
        >
          {wellaLanding ? 'POST JOB LISTING' : 'CREATE YOUR FREE ACCOUNT'}
        </Button>
        <span
          onClick={() => {
            if (history.location.pathname.includes(router_student_pro_landing)) {
              getStartedViaSource('jeffrey');
            } else if (history.location.pathname.includes('/wella')) {
              getStartedViaSource('wella');
            } else {
              redirectToGetStarted();
            }              
          }}
          className="sign-up-mobile"
        >
          {wellaLanding ? 'POST JOB' : 'CREATE YOUR ACCOUNT'}
        </span>
      </div>
    );
  }

  const handleAdmin = async () => {
    try {
      const storedInfo = sessionStorage.getItem("canvas:local:userInfo");
      
      // If no stored admin info, redirect to admin panel directly
      if (!storedInfo) {
        window.location.href = '/admin/users';
        return;
      }
      
      const info = JSON.parse(storedInfo);
      if (info.access_token) {
        const backPath = sessionStorage.getItem("canvas:local:adminpath");

        setToken(info.access_token);
        doAction(LoginWithTokenAction);
        doAction(setUserLoginInfoAction, {
          res: info,
          history: history!,
          ...(backPath ? { fromPage: backPath } : {}),
        });
      } else {
        // No access token found, redirect to admin panel
        window.location.href = '/admin/users';
      }
    } catch (error) { 
      console.log('Error going back to admin', error);
      // On any error, redirect to admin panel
      window.location.href = '/admin/users';
    }
  }

  useEffect(() => {
    if (token) {
      doAction(GetNotificationCount);
    }
    if (!curUser || !curUser.id) {
      doAction(LoginWithTokenAction);
    }
    doFunction(async () => {
      await initChatClient(curUser);
    });
    setIsAdmin(
      (curUser &&
        curUser.profile &&
        curUser.profile.target &&
        curUser.profile.target === TargetType.ADMIN) ||
        false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curUser]);

  const checkCanvasAndPost = async (type: string) => {
    setLoading(true);
    const canvasList = await searchMyCanvases(type, "all");
    setLoading(false);
    if (canvasList && !_.isEmpty(canvasList.list)) {
      const first = _.first(canvasList.list) as any;
      if (first && first.id) {
        const res = await getCanvas(first.id);
        if (res && res.job && res.job.max <= res.job.now) {
          message.error(
            "Your current membership and plan does not cover this opportunity post. Please check your membership setting or contact support at hello@beautista.com"
          );
          return;
        }
        doAction(MODULE_POST_JOB_OPP, module_post_job_opp);
        doFunction(async () => {
          history.push({
            pathname: router_dashboard_post_job_opp,
            search: `?id=${first.id}&isInMyAccount=1`,
          });
        });
      }
    } else {
      window.location.href = `${process.env.REACT_APP_NEXT_URL}/business/create`;
    }
  };

  const onPostOpportunityClick = useCallback(() => {
    if (!token) {
      history.push(router_get_started);
      return;
    }
    if (userCanvasFlags.hasBusinessCanvas) {
      checkCanvasAndPost("business");
      return;
    }
    if (userCanvasFlags.hasSchoolCanvas) {
      checkCanvasAndPost("school");
      return;
    }
    history.push({
      pathname: router_company_info,
      search: `?fromPost=true`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, history, userCanvasFlags]);

  return (
    <Header
      className={classnames(
        "header-root",
        className
      )}
      hidden={hidden}
    >
      <div
        className={`logo-sec`}
      >
        <a href={process.env.REACT_APP_NEXT_URL}>
          <img
            alt=""
            src={getOptimizedPath(LOGOS.white, 400)}
            className="logo"
            width={200}
            height={20}
          />
        </a>
      </div>
      <div className="left-sec">
        {!isLandingPage && (
          isLoggedIn ? (
            <>
              <a
                href={`${process.env.REACT_APP_NEXT_URL}/opportunities`}
                className="nav-opps"
              >
                OPPORTUNITIES
              </a>
              <a
                href={`${process.env.REACT_APP_NEXT_URL}/classes`}
                className="text nav-link-bold"
              >
                CLASSES
              </a>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key={router_homepage_canvas_professional}>
                      <Link to={router_homepage_canvas_professional}>
                        Professional Portfolios
                      </Link>
                    </Menu.Item>
                    <Menu.Item key={router_homepage_canvas_business}>
                      <Link to={router_homepage_canvas_business}>
                        Business Portfolios
                      </Link>
                    </Menu.Item>
                    <Menu.Item key={router_schol_canvas_business}>
                      <Link to={router_schol_canvas_business}>
                        School Portfolios
                      </Link>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <span className="text" style={{ color: "white" }}>
                  PORTFOLIOS
                  <img src={IconArrow} alt="" className="ic-arrow" />
                </span>
              </Dropdown>
              <a
                href={`${process.env.REACT_APP_NEXT_URL}/news`}
                className="text"
              >
                NEWS
              </a>
              <a href={TRIMM_URL}>
                <span className="text">THE TRIMM (NEWSLETTER)</span>
              </a>
            </>
          ) : (
            <>
            <a href={TRIMM_URL}>
              <span className="text">THE TRIMM (NEWSLETTER)</span>
            </a>
            <Dropdown overlay={
              <Menu>
                <Menu.Item key="salon-hiring">
                  <a href={`${process.env.REACT_APP_NEXT_URL}/exclusive-salon-offer`}>
                    Salon Hiring
                  </a>
                </Menu.Item>
                <Menu.Item key="brand-marketing">
                  <a href={`${process.env.REACT_APP_NEXT_URL}/brands`}>
                    Brand Marketing
                  </a>
                </Menu.Item>
                <Menu.Item key="school-marketing">
                  <a href={`${process.env.REACT_APP_NEXT_URL}/lp/school`}>
                    School Marketing & Placement
                  </a>
                </Menu.Item>
              </Menu>
            } 
            trigger={["click"]}>
              <span
                className="text"
                style={{ color: 'white' }}
              >
                SOLUTIONS
                <img src={IconArrow} alt="" className="ic-arrow" />
              </span>
            </Dropdown>
            <Dropdown overlay={
              <Menu>
                <Menu.Item key={router_homepage_opportunity}>
                  <a href={`${process.env.REACT_APP_NEXT_URL}/opportunities`}>
                    {" "}
                    View Opportunities
                  </a>
                </Menu.Item>
                <Menu.Item key={router_dashboard_post_job_opp} onClick={onPostOpportunityClick}>
                  Create Opportunity
                </Menu.Item>
              </Menu>
            } 
            trigger={["click"]}>
              <span
                className={`text ${
                  pathname?.includes(router_homepage_canvas.split(":")[0])
                    ? "active"
                    : ""
                } `}
                style={{ color: 'white' }}
              >
                OPPORTUNITIES
                <img src={IconArrow} alt="" className="ic-arrow" />
              </span>
            </Dropdown>
            <Dropdown overlay={
              <Menu>
                {!token && (
                  <Menu.Item key={router_add_canvas}>
                    <Link to={checkLoginThenGo(router_add_canvas)}>
                      Create a Porfolio
                    </Link>
                  </Menu.Item>
                )}
                <Menu.Item key={router_homepage_canvas_professional}>
                  <Link to={checkLoginThenGo(router_homepage_canvas_professional)}>
                    View Professional Portfolios
                  </Link>
                </Menu.Item>
                <Menu.Item key={router_homepage_canvas_business}>
                  <Link to={checkLoginThenGo(router_homepage_canvas_business)}>
                    View Business Portfolios
                  </Link>
                </Menu.Item>
                <Menu.Item key={router_homepage_canvas_business}>
                  <Link to={checkLoginThenGo(router_schol_canvas_business)}>
                    View School Portfolios
                  </Link>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}>
              <span
                className={`text ${
                  pathname?.includes(router_homepage_canvas.split(":")[0])
                    ? "active"
                    : ""
                }`}
                style={{ color: 'white' }}
              >
                PORTFOLIOS
                <img src={IconArrow} alt="" className="ic-arrow" />
              </span>
            </Dropdown>
            <Dropdown overlay={
              <Menu>
                {/* <Menu.Item key={router_homepage_canvas_professional}>
                  <a href="https://sites.canvasme.com/video/">How it Works</a>
                </Menu.Item> */}
                <Menu.Item key={router_homepage_canvas_business}>
                  <HashLink smooth to="/#faq">
                    FAQs
                  </HashLink>
                </Menu.Item>
                <Menu.Item key={partnersUrl}>
                  <a href={partnersUrl}>Partners</a>
                </Menu.Item>
                <Menu.Item key={`${process.env.REACT_APP_NEXT_URL}/chair-loss-roi-calculator`}>
                  <a href="/chair-loss-roi-calculator">Chair Loss ROI Calculator</a>
                </Menu.Item>
              </Menu>
            } 
            trigger={["click"]}>
              <span
                className={`text ${
                  pathname?.includes(router_homepage_canvas.split(":")[0])
                    ? "active"
                    : ""
                }`}
                style={{ color: 'white' }}
              >
                RESOURCES
                <img src={IconArrow} alt="" className="ic-arrow" />
              </span>
            </Dropdown>
            {/* <a href={`${process.env.REACT_APP_NEXT_URL}/redken/redken-global-masterclass-creative-control-artistic-blonding-precision-2025-12-08-10-00am-est`}>
              <span className="text">REDKEN MASTERCLASS</span>
            </a> */}
            {/* <a href={`${process.env.REACT_APP_NEXT_URL}/classes`}>
              <span style={{ color: '#FFFFFF', fontSize: '14px', fontWeight: 'bold', marginLeft: '10px' }}>CLASSES</span>
            </a> */}
            </>
          )
        )}
      </div>
      <div className="right-sec">
        {/* Show "Back to admin" button when admin is acting on behalf of a user */}
        {token && curUser?.adminBehalf && (
            <MatButton
              className="back-btn"
              onClick={handleAdmin}
              variant="outlined"
            >
              Back to admin
            </MatButton>
          )}
        {/* {!!token && (
          <MatButton
            className="btn-primary post-opportunity-btn"
            onClick={onPostOpportunityClick}
            hidden={isHome || isAdmin}
          >
            Post Opportunity
          </MatButton>
        )} */}
        {userMenu}
        <img
          alt=""
          src={IconMenu}
          className="ic-menu"
          onClick={() => setShowMenuModal(true)}
        />
      </div>
      <HomeMenuModal
        onPostOpportunityClick={onPostOpportunityClick}
        visible={showMenuModal}
        onClose={() => setShowMenuModal(false)}
        history={history}
        onLogout={() => {
          setShowMenuModal(false);
          onLogout && onLogout();
        }}
        onLogin={() => {
          setShowMenuModal(false);
          onLogin &&
            (history.location.pathname !== "/paulmitchell"
              ? onLogin()
              : history.push("/sign-in"));
        }}
        isLogin={isLoggedIn}
        user={curUser}
        userCanvasFlags={userCanvasFlags}
      />
      <CommonLoadingModal visible={loading} closable={false} />
    </Header>
  );
};

export default mapProp(
  module_notifications,
  "notificationCount"
)(mapProp(module_chat)(mapProp(modle_user)(CRHeader)));
